export const CREDIT_PACKS_EMPTY_MESSAGE =
  "No credit packs exist for this tenant yet";
export const CREDIT_PACKS_ERROR_MESSAGE =
  "Failed to load credit packs. Please try again.";

export const CREDIT_PACK_FORM_DESCRIPTION =
  "Creates a batch of AI analyst credits for this account. Credits Purchased is the number of credits; Purchase Date defaults to now and Expiry Date defaults to Purchase Date + 365 days; Batch Type defaults to 'Starter pack'. Every create is recorded in the tenant audit log (action, timestamp, user).";

export const CREDIT_PACK_CREATED_MESSAGE = "Credit pack created";
export const CREDIT_PACK_SUBMIT_ERROR_MESSAGE =
  "Something went wrong. Please try again.";

export const CREDITS_MUST_BE_POSITIVE_MESSAGE =
  "Credits must be greater than 0";
export const EXPIRY_AFTER_PURCHASE_MESSAGE =
  "Expiry date must be after the purchase date";
export const EXPIRY_NOT_PAST_MESSAGE = "Expiry date cannot be in the past";

export const PURCHASE_DATE_LABEL = "Purchase date";
export const EM_DASH = "—";

export const BATCH_TYPE = {
  STARTER_PACK: "Starter pack",
  PURCHASED: "Purchased",
} as const;
export type BatchTypeValue = (typeof BATCH_TYPE)[keyof typeof BATCH_TYPE];

export const BATCH_TYPE_OPTIONS: { id: string; name: string }[] = [
  { id: BATCH_TYPE.STARTER_PACK, name: BATCH_TYPE.STARTER_PACK },
  { id: BATCH_TYPE.PURCHASED, name: BATCH_TYPE.PURCHASED },
];
